/**
 * US footer overrides (BC-4427). Mirrors the style of `hde-country-gating.ts`
 * — pure structural helpers + a US-specific replacement for the Memberships
 * group, consumed by `AppPage.tsx` when assembling the footer columns.
 */

export const isUS = (countryCode: string): boolean =>
    countryCode.toUpperCase() === 'US';

interface FooterGroupShape {
    links: Array<{ title: string }>;
}

/**
 * Returns a copy of the group with any link whose `title` appears in
 * `titlesToHide` removed. Structurally typed so it works against either the
 * Rocco footer or header link shapes.
 */
export const filterFooterGroupLinks = <T extends FooterGroupShape>(
    group: T,
    titlesToHide: ReadonlyArray<string>,
): T => {
    const hide = new Set(titlesToHide);
    return {
        ...group,
        links: group.links.filter((link) => !hide.has(link.title)),
    };
};

/**
 * US-only Memberships column. Replaces the external
 * `business.{AP_DOMAIN_PLACE}/memberships/for-*` links with the internal
 * Remix routes shipped under `/b2b/*` for the US launch.
 */
export const US_FOOTER_MEMBERSHIP_LINKS = {
    title: 'Memberships',
    links: [
        { title: 'For Professionals', to: '/b2b/professionals' },
        { title: 'For Suppliers', to: '/b2b/brands' },
    ],
};
